import _ from "lodash";

export function TpRoleToTp(
  rolcode: string,
  tprole: any,
  tpname: string,
  tpreference: string,
  ctrid?: number
): any {
  return {
    ctrid: ctrid ?? 0,
    tpname: tpname,
    enddate: '',
    mfagreedamount: 0,
    mfavailableamount: 0,
    mfbookedamount: 0,
    mfrequestedamount: 0,
    mfusedamount: 0,
    mfvaliditydate: '',
    startdate: '',
    status: rolcode === 'MFBENEF' ? 'ACTIVE' : tprole?.status,
    statusdate: tprole?.statusdate,
    tpadrid: tprole?.tpadrid,
    tpbkidin: tprole?.tpbkidin,
    tpbkidout: tprole?.tpbkidout,
    tpblocklateinterestinvoicing: tprole?.tpblocklateinterestinvoicing,
    tpblockrejectionfeesinvoicing: tprole?.tpblockrejectionfeesinvoicing,
    tpblockreminderfeesinvoicing: tprole?.tpblockreminderfeesinvoicing,
    tpid: { tpid: tprole?.tpid, tpname: tpname, tpreference: tpreference },
    tplateinterestformula: tprole?.tplateinterestformula,
    tppaydelayin: tprole?.tppaydelayin ?? '',
    tppaydelayout: tprole?.tppaydelayout,
    tppaymodein: tprole?.tppaymodein ?? '',
    tppaymodeout: tprole?.tppaymodeout,
    tprejectionfeesformula: tprole?.tprejectionfeesformula,
    tpreminderfeesformula: tprole?.tpreminderfeesformula,
    tprolecode: rolcode,
    tproleid: Math.floor(_.random(10000) * 10000000) * -1,
    isNew: true,
  };
}
